import React, {useState, useEffect} from 'react'
import Header from '../components/common/header'
import { Layout } from 'antd';
import { Button, Card, Col, Collapse, CollapseProps, Row, Typography } from 'antd'
import { useNavigate } from 'react-router-dom';
import AppFooter from '../components/common/footer';
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import image_faq_back_right from '../assets/images/txn_right.png'
import image_faq_back from '../assets/images/txn_left.png'
import back_img from '../assets/images/faq_back_img.png'


const { Content, Footer } = Layout;

export type Section =
  | "home"
  | "transaction"
  | "services"
  | "clients"
  | "questions"
  | "registrationform";

  interface FaqItem {
    key: string;
    label: React.ReactNode;
    children: React.ReactNode;
}

interface Props {
    faqData1: FaqItem[];
    faqData2: FaqItem[];
    faqData3: FaqItem[];
    faqData4: FaqItem[];
    faqData5: FaqItem[];
}

const faqData1: FaqItem[] = [
    {
        key: '1',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> What is the Central Identities Data Repository (CIDR)?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>CIDR is the secure central database maintained by UIDAI that stores Aadhaar numbers along with demographic and biometric information of residents. Authentication requests are verified against the data stored in CIDR.</Typography>,
    },
];

const faqData2: FaqItem[] = [
    {
        key: '2',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}>What are the key components of the ASA–AUA architecture?</Typography>,
        children: <div>
            <Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>Typical architecture includes:</Typography>
            <ul><Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>
                <li>AUA application server</li>
                <li>ASA gateway</li>
                <li>Secure connectivity to UIDAI</li>
                <li>Encryption and signing modules (HSM)</li>
                <li>Authentication API integration</li>
            </Typography></ul>
            {/* </Typography> */}
        </div>
        ,
    },
];

const faqData3: FaqItem[] = [
    {
        key: '3',
        label:
            <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> What is the difference between AUA and KUA?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>An AUA receives only a Yes/No authentication response, whereas a KUA can receive verified demographic data for KYC purposes after obtaining the Aadhaar holder’s consent.</Typography>,
    },
];

const faqData4: FaqItem[] = [
    {
        key: '4',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}>How do AUAs connect to UIDAI systems?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>AUAs connect to UIDAI through an ASA that provides secure connectivity and routes authentication requests to CIDR.</Typography>,
    },
];

const faqData5: FaqItem[] = [
    {
        key: '5',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> Can an organization connect directly to CIDR?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>No. Only authorized ASAs with secure connectivity are allowed to send requests to CIDR. Other entities must connect through an ASA.</Typography>,
    },
];
const faqData6: FaqItem[] = [
    {
        key: '6',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> Can AUAs store biometric data?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>No. Biometric information used for authentication must not be stored by AUAs or KUAs unless specifically permitted under UIDAI regulations.</Typography>,
    },
];
const faqData7: FaqItem[] = [
    {
        key: '7',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> Are AUAs and KUAs subject to compliance requirements?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>Yes. AUAs and KUAs must comply with UIDAI regulations, Aadhaar Act provisions, and security policies governing authentication and data protection.</Typography>,
    },
];
const faqData8: FaqItem[] = [
    {
        key: '8',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}> Are Sub-AUAs allowed?</Typography>,
        children: <Typography style={{ textAlignLast: 'left', fontSize: '16px' }}>Yes. Authorized AUAs may enable Sub-AUAs to perform authentication through their infrastructure under UIDAI-approved arrangements.</Typography>,
    },
];
const faqData9: FaqItem[] = [
    {
        key: '9',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}>What is the onboarding process for becoming an AUA or KUA?</Typography>,
        children: <div>
            <Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>Typical onboarding steps include:</Typography>
            <ul><Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>
                <li>Application submission to UIDAI</li>
                <li>Eligibility verification</li>
                <li>Signing agreements with UIDAI</li>
                <li>Integration testing</li>
                <li>Security compliance validation</li>
                <li>Production approval</li>
            </Typography></ul>
            {/* </Typography> */}
        </div>
        ,
    },
];
const faqData10: FaqItem[] = [
    {
        key: '10',
        label: <Typography style={{ color: '#0400ab', fontSize: '16px', fontWeight: 'bold' }}>Who can apply to become an AUA or KUA?</Typography>,
        children: <div>
            <Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>Eligible entities include:</Typography>
            <ul><Typography style={{ textAlignLast: 'left', fontSize:'16px' }}>
                <li>Government departments</li>
                <li>Banks and financial institutions</li>
                <li>Telecom companies</li>
                <li>Public or private organizations registered in India.</li>
            </Typography></ul>
            {/* </Typography> */}
        </div>
        ,
    },
];

function FAQMore() {
    const [active, setActive] = useState<Section>("home");
 const [activeKey, setActiveKey] = useState<string | null>(null);
    const navigate = useNavigate();
    // Combine prefix with key for uniqueness across all collapses
    const getItemsWithPrefixedKeys = (items: FaqItem[], prefix: string): CollapseProps['items'] =>
        items.map((item) => ({
            ...item,
            key: `${prefix}-${item.key}`,
        }));

    const handleChange = (key: string | string[] | null, prefix: string) => {
        let newKey: string | null = null;

        if (Array.isArray(key)) {
            newKey = key[0] || null;
        } else if (typeof key === 'string') {
            newKey = key;
        }

        // Toggle if same key clicked, else open new
        setActiveKey((prevKey) => (prevKey === newKey ? null : newKey));
    };

    const renderCollapse = (data: FaqItem[], prefix: string) => (
        <Collapse 
        style={{ 
            // boxShadow: '0px 0px 7px 0px #0000ff4a', 
            background: 'white' 
        }}
            accordion
            activeKey={activeKey?.startsWith(`${prefix}-`) ? activeKey : undefined}
            onChange={(key) => handleChange(key, prefix)}
            items={getItemsWithPrefixedKeys(data, prefix)}
            expandIcon={({ isActive }) => (
                <div
                    style={{
                        backgroundColor: '#9bcfff',
                        borderRadius: '50%',
                        padding: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '24px',
                        height: '24px',
                    }}
                >
                    <DownOutlined rotate={isActive ? 180 : 0} style={{ color: 'blue' }} />
                </div>
            )}
            expandIconPosition="end"
            
        />
    );
  return (
    <div>
      <Header active={active} />
<section id="faq" style={{ scrollMarginTop: '70px' }}>
<Card style={{ backgroundImage: `url(${back_img})`, backgroundColor: '#dfd7ff', marginBottom: '12px',  }}>
    <h1 style={{fontWeight: '600', fontSize: '2.5rem'}}>Frequently Asked Questions</h1>
</Card>
            <div className="container-fluid">
                {/* <div className="titleHolder">
                    <h2>Have Questions?</h2>

                </div> */}
                <Row gutter={[16, 16]} style={{ padding: '0px 0px 30px 0px', placeItems: 'center' }}>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {renderCollapse(faqData1, 'faq1')}
                        {renderCollapse(faqData2, 'faq2')}
                        {renderCollapse(faqData3, 'faq3')}
                        {renderCollapse(faqData4, 'faq4')}
                        {renderCollapse(faqData5, 'faq5')}
                        {renderCollapse(faqData6, 'faq6')}
                        {renderCollapse(faqData7, 'faq7')}
                        {renderCollapse(faqData8, 'faq8')}
                        {renderCollapse(faqData9, 'faq9')}
                        {renderCollapse(faqData10, 'faq10')}
                    </Col>

                </Row>
            </div>
        </section>
              <Footer>
          <AppFooter />
        </Footer>
    </div>
  )
}

export default FAQMore
